export default __webpack_public_path__ + "static/media/download.88e3cfc6.webp";